"use client";
//import node module libraries
import Link from "next/link";
import { useTheme } from "next-themes";
import { usePathname } from "next/navigation";
import { CircleHelp, Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";

//import routes
import { chatSidebarLinks } from "@/routes/routes";

//import custom shadcn UI components
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from "../ui/tooltip";

import { ReactElement, useEffect, useState } from "react";

const Sidebar = () => {
  const pathname = usePathname();
  const { theme, setTheme, systemTheme } = useTheme();

  const [themeIcon, setThemeIcon] = useState<ReactElement | null>(null);

  const changeThemeIcon = (mode: string) =>
    setThemeIcon(mode === "light" ? <Moon size={22} /> : <Sun size={22} />);

  // Setting theme based on system theme
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
      changeThemeIcon(savedTheme);
      return;
    }
    

    const newTheme = systemTheme === "dark" ? "light" : "light";
    setTheme(newTheme);
    changeThemeIcon(newTheme);
    localStorage.setItem("theme", newTheme);
  }, [systemTheme, setTheme]);

  const handleThemeToggle = () => {
    const currentTheme = theme === "system" ? systemTheme : theme;
    const newTheme = currentTheme === "light" ? "dark" : "light";
    setTheme(newTheme);
    changeThemeIcon(newTheme);
  };

  return (
    <aside className="h-screen w-16 bg-black dark:bg-black text-white  flex flex-col justify-between">
      <ul className="flex flex-col items-center gap-6 px-2 sm:py-5">
        {chatSidebarLinks.map((item) => (
          <TooltipProvider key={item.id}>
            <Tooltip>
              <TooltipTrigger asChild>
                <span style={{ display: "contents" }}>
                  <motion.li
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    whileTap={{ scale: 0.85 }}
                  >
                    <Link
                    href={item.link}
                    className={`flex h-10 w-10 items-center justify-center rounded-md text-slate-100 transition-colors hover:text-foreground
                    ${
                      pathname === item.link ||
                      pathname.includes(`${item.link}`)
                        ? "bg-orange-500 dark:bg-orange-500"
                        : ""
                    }
                    `}
                  >
                    {item.icon}
                    <span className="sr-only">{item.title}</span>
                  </Link>
                  </motion.li>
                </span>
              </TooltipTrigger>
              <TooltipContent side="right">{item.title}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ))}
      </ul>
      <ul className="flex flex-col items-center gap-4 sm:py-5">
        {/* <motion.li
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          whileTap={{ scale: 0.85 }}
        >
          <CustomTooltip
            content={`${theme === "dark" ? "Light Mode" : "Dark Mode"}`}
          >
            <Button
              size={"icon"}
              variant={"ghost"}
              onClick={handleThemeToggle}
              className={
                "text-neutral-100 dark:bg-transparent dark:text-zinc-100"
              }
            >
              {themeIcon}
            </Button>
          </CustomTooltip>
        </motion.li> */}
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span style={{ display: "contents" }}>
                <motion.li
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  whileTap={{ scale: 0.85 }}
                >
                  <Link
                    href={"/support"}
                  className={`flex h-10 w-10 items-center justify-center rounded-lg text-slate-100 transition-colors hover:text-foreground
                  ${
                    pathname === "/support" || pathname.includes("/support")
                      ? "bg-orange-500 dark:bg-orange-500"
                      : ""
                  }
                  `}
                >
                  <CircleHelp />
                  <span className="sr-only">Support</span>
                  </Link>
                </motion.li>
              </span>
            </TooltipTrigger>
            <TooltipContent side="right">Support</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </ul>
    </aside>
  );
};

export default Sidebar;
